import { useCallback } from 'react'

import { useEditAppInstanceBulkApi } from 'api/apps/mutations/useEditAppInstanceBulkApi'
import { invalidateHierarchyNodeAppInstances } from 'components/hierarchyAppsManagement/utils'
import { AppInstancePositionBulkEditDTO } from 'types/apps/appInstances'

interface Props {
  data: AppInstancePositionBulkEditDTO[]
  assignmentId: string
}

export const useUpdateAppsPosition = () => {
  const { mutateAsync: handleEditAppInstanceBulkApi } = useEditAppInstanceBulkApi()

  const updateAppsPosition = useCallback(
    ({ data, assignmentId }: Props) => {
      Promise.all([
        handleEditAppInstanceBulkApi({
          data,
        }),
      ]).finally(() => invalidateHierarchyNodeAppInstances(assignmentId))
    },
    [handleEditAppInstanceBulkApi],
  )

  return { updateAppsPosition }
}
